<mat-toolbar color="primary"
  class="w-100 align-items-center">
  <button mat-icon-button
    (click)="openMenu()">
    <mat-icon>menu</mat-icon>
  </button>
  <div class="border-right px-4 mr-4">
    <soh-logo></soh-logo>
  </div>

  <div class="user-type">
    <span>{{'HEADER.USER_TYPE.STORE_OPERATOR' | translate}}</span>
  </div>

  <span class="d-flex flex-grow-1"></span>

  <button mat-button
    class="user-account-button"
    [matMenuTriggerFor]="menu">
    <span>
      {{storeService.store?.user?.username}}
    </span>
    <mat-icon class="ml-2">
      <span class="online-indicator"
        [ngClass]="{'online': bitfPwaService.onlineStatus === eBitfOnlineStates.ONLINE, 'offline': bitfPwaService.onlineStatus === eBitfOnlineStates.OFFLINE}"
        [matTooltip]="(bitfPwaService.onlineStatus === eBitfOnlineStates.ONLINE) ? 'Online' : 'Offline'"></span>
      account_circle
    </mat-icon>
  </button>

  <mat-menu #menu="matMenu">
    <button mat-menu-item
      [routerLink]="['auth','sign-out']">
      {{'SIGN_OUT.SIGN_OUT_BTN' | translate}}
    </button>
  </mat-menu>
</mat-toolbar>